import cancelPlaceOrderConfirmation from './cancel-place-order-confirmation'
import checkoutInProgress from './checkout-in-progress'
import declineOrderConfirmation from './decline-order-confirmation'
import userRequired from './user-required'

export default {
  cancelPlaceOrderConfirmation,
  checkoutInProgress,
  declineOrderConfirmation,
  userRequired,
}
